import React from "react";
import { ReactComponent as SuccessImg } from "../../../assets/illustrations/kyc-done-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";

export const VerificationSuccessPage: React.FC = () => {
  return (
    <ServicesLayout image={<SuccessImg />} title="Your identity is verified!">
      <div className="text-base theme-text-secondary">
        Enjoy making as many invoices as you want and share them with your
        clients.
      </div>
    </ServicesLayout>
  );
};
